import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
// import { verifyQuestion, rejectQuestion } from '../../common/redux/actions/GroupsActions';

export default function ProblemMessage(props) {
  const profile = useSelector((state) => state.ProfileState.data);
  return (
    <div className={`problemMessageBox ${props.message.user === profile.id ? 'myMessage' : 'yourMessage'}`}>
      {props.message.message}
    </div>
  );
}

ProblemMessage.contextTypes = {
  t: PropTypes.func.isRequired
};
